import { Component, Injector, OnInit} from '@angular/core';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';


@Component({
  selector: 'laas-forwarder-setting',
  templateUrl: './forwarder-setting.component.html',
  styleUrls: ['./forwarder-setting.component.scss']
})
export class ForwarderSettingComponent
  extends SessionBaseComponent implements OnInit {
  readonly viewPermissionCode = PermissionConstants.ViewForwarderSetting;
  currentLang: string = this.laasSetting.language;
  selectedTabIndex: number = 0;

  constructor(private injector: Injector) {super(injector);}

  async ngOnInit(): Promise<void> {

  }

}
